import { render, staticRenderFns } from "./expenses.vue?vue&type=template&id=c1d5375c"
import script from "./expenses.vue?vue&type=script&lang=js"
export * from "./expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports